export const entity = {
    name: 'NatureOfHelp',
    facets: ['codeName'],
    fields: [
        {path: 'eligibleToEmergencyFund', type: 'boolean'},
        {path: 'facilityRelated', type: 'boolean'},
        {path: 'unit', type: 'UnitList'},
        {path: 'active', type: 'boolean'},
        {
            path: 'nameWithUnit',
            fieldPath: ['name', 'unit.name'],
            f: function() {
                return this.name + ' (' + this.unit?.name + ')'
            }
        },
    ],
    filters: [
        {
            name: 'eligibleToEmergencyFund',
            isDefault: false,
            query: () => ({eligibleToEmergencyFund: true})
        },
        {
            name: 'facilityRelated',
            isDefault: false,
            query: () => ({facilityRelated: true})
        },
        {
            name: 'isActive',
            isDefault: false,
            query: () => ({active: true})
        }
    ]
}


export const module_ = {
    object: 'NatureOfHelp',
    tKey: 'mTitle_natureOfHelp',
    category: {
        path: 'menuTitle_configuration',
        icon: 'settings'
    },
    viewMap: {
        dt: [
            {path: 'code'},
            {path: 'name'},
            'unit',
            {path: 'eligibleToEmergencyFund', width: 300},
            {path: 'facilityRelated', width: 250},
            'active'
        ],
        form: [
            {path: 'code'},
            {path: 'name'},
            'unit',
            'eligibleToEmergencyFund',
            'facilityRelated',
            'active'
        ]
    }
}
